module.exports = __webpack_public_path__ + "static/media/polos.e9b46ace.jpg";